import { valueStoreFactory } from 'services/utils/valueStoreFactory';

export const chatClientValueStore = valueStoreFactory();
